import React, { useEffect, useRef, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { LuCalendarPlus } from "react-icons/lu";
import { getDoughnutChartFormattedData } from "../../services/commonServices";

ChartJS.register(ArcElement, Tooltip, Legend);

const GradientDoughnutChart = ({ pieData }) => {
  const { chartLabels, chartValues } =
    getDoughnutChartFormattedData(pieData);

  const chartRef = useRef();
  const [hiddenIndexes, setHiddenIndexes] = useState([]);

  const chartColors = ["#31BB79", "#FFDD81", "#FD5F5F", "#4EA1FF", "#7d3c98"];

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: "#fff",
        titleColor: "#000",
        bodyColor: "#000",
        usePointStyle: true,
        boxWidth: 8,
        cornerRadius: 6,
        titleFont: {
          family: "Outfit",
          size: 14,
        },
        bodyFont: {
          family: "Outfit",
          size: 13,
        },
        footerFont: {
          family: "Outfit",
          size: 12,
        },
        callbacks: {
          label: function (context) {
            // const dataset = context.dataset.data;
            // const total = dataset.reduce((acc, val) => acc + val, 0);
            const value = context.raw;
            // const percentage = ((value / total) * 100).toFixed(1); // 1 decimal
            return `${value}%`;
            // return `${value} (${percentage}%)`;
          },
        },
      },
    },
  };

  const generateGradients = (ctx, chartArea) => {
    const gradients = [];

    const gradient1 = ctx.createLinearGradient(0, 0, 0, 175);
    gradient1.addColorStop(0, "#167145");
    gradient1.addColorStop(1, "#31BB79");

    const gradient2 = ctx.createLinearGradient(0, 0, 175, 0);
    gradient2.addColorStop(0, "#FFBD08");
    gradient2.addColorStop(1, "#FFDD81");

    const gradient3 = ctx.createLinearGradient(0, 175, 0, 80);
    gradient3.addColorStop(0, "#E33A3A");
    // gradient3.addColorStop(0.5, "#E33A3A");
    // gradient3.addColorStop(0.8, "#FD5F5F");
    gradient3.addColorStop(1, "#FD5F5F");

    const gradient4 = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
    gradient4.addColorStop(0, "#4EA1FF");
    gradient4.addColorStop(1, "#0278FF");

    const gradient5 = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
    gradient5.addColorStop(0, "#ad69fc");
    gradient5.addColorStop(1, "#841bfc");

    gradients.push(gradient1, gradient2, gradient3, gradient4, gradient5);
    return gradients;
  };

  const data = {
    labels: chartLabels,
    datasets: [
      {
        data: chartValues,
        backgroundColor: (ctx) => {
          const chart = ctx.chart;
          const { ctx: canvasCtx, chartArea } = chart;

          if (!chartArea) return []; // Wait until chart is ready

          const gradients = generateGradients(canvasCtx, chartArea);
          return chartValues.map((_, i) => gradients[i % gradients.length]);
        },
        cutout: "68%",
        borderRadius: 50,
        borderWidth: 0,
      },
    ],
  };

  const handleLegendClick = (index) => {
    const chart = chartRef.current;
    if (!chart) return;

    const meta = chart._metasets[0] || chart.getDatasetMeta(0);
    const isHidden = meta.data[index].hidden;

    meta.data[index].hidden = !isHidden;
    chart.update();

    setHiddenIndexes((prev) =>
      isHidden ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between">
        <div
          className="d-flex align-items-center justify-content-start gap-2"
          style={{ position: "relative", top: "-25px" }}
        >
          <div className="universal-btn">
            <LuCalendarPlus />
          </div>
          <h3 className="color-white">Attendance Summary</h3>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-between gap-2">
        <div
          style={{
            width: "100%",
            minWidth: "200px",
            maxWidth: "250px",
            height: "320px",
          }}
        >
          <Doughnut
            data={data}
            options={options}
            ref={chartRef}
          />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          {chartLabels.map((label, index) => (
            <div
              key={label}
              onClick={() => handleLegendClick(index)}
              style={{
                fontSize: "14px",
                textWrap: "nowrap",
                cursor: "pointer",
                opacity: hiddenIndexes.includes(index) ? 0.4 : 1,
              }}
              className="color-white"
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor: chartColors[index],
                    display: "inline-block",
                  }}
                />
                {label}
              </div>
              <div style={{ fontWeight: "bold", marginLeft: "18px" }}>
                {chartValues[index]}%
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GradientDoughnutChart;


